export const TYPE_LIST = 'list'
export const TYPE_MULTIPLE = 'input_multiselect'
export const TYPE_CONSTANT_VALUE = 'constant_value'
export const TYPE_INPUT_NUMBER = 'input_number'
export const TYPE_INPUT_TEXT = 'input_string'
export const TYPE_INPUT_FILE = 'file_only'
export const TYPE_INPUT_BOOLEAN = 'input_boolean'
export const TYPE_INPUT_TEXTAREA = 'comment_only'
export const TYPE_INPUT_DATE = 'input_date'
export const TYPE_COLLECTION = 'collection'

export const EVENT_CATEGORY_COLORS = [
  '#4C72B9',
  '#9894E4',
  '#4B4697',
  '#87A4FF',
  '#3fbcd4',
  '#7a9853',
  '#a1ca69',
  '#efc350',
  '#78F7FF',
  '#93BEFF',
  '#26BFF1',
  '#CECBFF',
  '#0196DB',
  '#02325C',
  '#BA7093',
  '#D95996',
  '#FFEB3B',
  '#FFC107',
  '#33691E',
  '#9ac7d0',
  '#3b5998',
  '#55acee',
  '#00bbff',
  '#1DC7EA',
  '#87CB16',
  '#FFA534',
  '#9368E9',
  '#FB4010',
]

export const getFileObject = () => ({
  id: null,
  mimeType: null,
  originalName: null,
  path: null,
  size: null,
  uri: null,
})

export const ifLogbookConstant = format => {
  const logbookConstantPrefixes = ['logbook_category', 'logbook_event']

  return value => {
    const sanitized = (value || '').toString()

    return logbookConstantPrefixes.some(p => sanitized.startsWith(p))
      ? format({ id: value })
      : value
  }
}
